import { useEffect } from "react";
import { useSelector } from "react-redux";

const ChangeThemes = () =>{
    const themeName = useSelector((e: any) => e.themeName);

    useEffect(()=>{
        console.log("s ::themeName :: ", themeName);
        
        if(themeName === "BLACK"){
            console.log("s ::BLACK");
            // document.documentElement.style.setProperty('--primary', `#f5db21`);
            // document.documentElement.style.setProperty('--secondary', `#222222`);
            // Header Start
            document.documentElement.style.setProperty('--header-bg', `#212121`);
            document.documentElement.style.setProperty('--header-deposit-btn-bg', `linear-gradient(180deg, #ffee35 0%, #e5ba00 100%)`);
            // document.documentElement.style.setProperty('--header-deposit-btn-txt', `#222222`);
            document.documentElement.style.setProperty('--header-register-btn-bg', `linear-gradient(180deg, #ffffff 0%, #d4d4d4 100%)`);
            // document.documentElement.style.setProperty('--header-register-btn-txt', `#222222`);
            // Header End
            // document.documentElement.style.setProperty('--nav-category-bg-active-circle', `linear-gradient(#464646 0%, #222222 100%)`);
            // document.documentElement.style.setProperty('--nav-category-txt', `#222222`);
            // document.documentElement.style.setProperty('--nav-category-txt-active', `#f5db21`);
            document.documentElement.style.setProperty('--nav-item-bg', `#333333`);
            document.documentElement.style.setProperty('--color-title', `#ffffff`);
            document.documentElement.style.setProperty('--event-title', `#ffffff`);
            document.documentElement.style.setProperty('--announvement-txt', `#ffffff`);
            // document.documentElement.style.setProperty('--inset-shadow', `#ffffff`);
            document.documentElement.style.setProperty('--nav-bg', `linear-gradient(180deg, #ffee35 0%, #e5ba00 100%)`);
            document.documentElement.style.setProperty('--sidenav-category-bg-active', `rgba(255, 255, 255, .2)`);
            document.documentElement.style.setProperty('--sidenav-wallet-icon-bg', `rgba(34, 34, 34, .3)`);
            document.documentElement.style.setProperty('--footer-bg', `transparent`);
            
            document.documentElement.style.setProperty('--content-bg', `#111111`);
            document.documentElement.style.setProperty('--offset-shadow', `#ffffff`);
            // document.documentElement.style.setProperty('--color-title', `#222222`);
            document.documentElement.style.setProperty('--form-input-bg', `#484848`);
            // document.documentElement.style.setProperty('--form-clear-icon-color', `#ffd259`);
            // document.documentElement.style.setProperty('--form-eyes-icon-color', `#ffffff`);
            // document.documentElement.style.setProperty('--btn-main-txt', `#222222`);
            // Footer
            document.documentElement.style.setProperty('--footer-title', `#ffffff`);
            document.documentElement.style.setProperty('--footer-area-bg', `#333333`);
            // Sidebar
            document.documentElement.style.setProperty('--sidenav-category-bg', `linear-gradient(226deg, #2e2e2e 0%, #222222 100%)`);
            document.documentElement.style.setProperty('--sidenav-category-txt', `#ffffff`);
            // document.documentElement.style.setProperty('--sidenav-mask', `rgba(0, 0, 0, 0.5)`);
            document.documentElement.style.setProperty('--sidenav-category-columns-bg', `linear-gradient( 226deg, #2e2e2e 0%, #222222 100% )`);
            //
            document.documentElement.style.setProperty('--pop-search-header-bg', `#212121`);
            document.documentElement.style.setProperty('--pop-search-input-bg', `#484848`);
            document.documentElement.style.setProperty('--pop-search-back-icon-color', `#ffffff`);
            document.documentElement.style.setProperty('--search-bg', `#333333`);
            document.documentElement.style.setProperty('--search-item-bg', `#484848`);
            document.documentElement.style.setProperty('--search-item-bg-active', `#ffd259`);
            document.documentElement.style.setProperty('--search-item-txt', `#ffffff`);
            document.documentElement.style.setProperty('----provider-bg', `#333333`);
            document.documentElement.style.setProperty('----provider-text', `#ffffff`);
            document.documentElement.style.setProperty('----game-bg', `#111111`);

            
        }else{
            console.log("s ::WHITE");
            document.documentElement.style.setProperty('--primary', `#f5db21`);
            document.documentElement.style.setProperty('--secondary', `#222222`);
            // Header Start
            document.documentElement.style.setProperty('--header-bg', `#ffffff`);
            document.documentElement.style.setProperty('--header-deposit-btn-bg', `linear-gradient(180deg, #ffee35 0%, #e6cd1b 100%)`);
            document.documentElement.style.setProperty('--header-deposit-btn-txt', `#222222`);
            document.documentElement.style.setProperty('--header-register-btn-bg', `linear-gradient(180deg, #f2f2f2 0%, #eae9e9 100%)`);
            document.documentElement.style.setProperty('--header-register-btn-txt', `#222222`);
            // Header End
            document.documentElement.style.setProperty('--nav-category-bg-active-circle', `linear-gradient(#464646 0%, #222222 100%)`);
            document.documentElement.style.setProperty('--nav-category-txt', `#222222`);
            document.documentElement.style.setProperty('--nav-category-txt-active', `#f5db21`);
            document.documentElement.style.setProperty('--nav-item-bg', `#ffffff`);
            document.documentElement.style.setProperty('--color-title', `#222222`);
            document.documentElement.style.setProperty('--event-title', `#222222`);
            document.documentElement.style.setProperty('--announvement-txt', `#222222`);
            document.documentElement.style.setProperty('--inset-shadow', `#ffffff`);
            document.documentElement.style.setProperty('--nav-bg', `linear-gradient(#f7e354 0%, #f5db21 100%)`);
            document.documentElement.style.setProperty('--sidenav-category-bg-active', `rgba(161, 160, 255, .3)`);
            document.documentElement.style.setProperty('--sidenav-wallet-icon-bg', `rgba(255, 255, 255, .1)`);
            document.documentElement.style.setProperty('--footer-bg', `#ebebeb`);
            document.documentElement.style.setProperty('--content-bg', `#ebebeb`);
            document.documentElement.style.setProperty('--offset-shadow', `#222222`);
            document.documentElement.style.setProperty('--color-title', `#222222`);
            document.documentElement.style.setProperty('--form-input-bg', `#f2f2f2`);
            document.documentElement.style.setProperty('--form-clear-icon-color', `#ffd259`);
            document.documentElement.style.setProperty('--form-eyes-icon-color', `#ffffff`);
            document.documentElement.style.setProperty('--btn-main-txt', `#222222`);
            // Footer
            document.documentElement.style.setProperty('--footer-title', `#222222`);
            document.documentElement.style.setProperty('--footer-area-bg', `#ffffff`);
            // Sidebar
            document.documentElement.style.setProperty('--sidenav-category-bg', `linear-gradient(45deg, #ffffff 0%, #efefef 100%)`);
            document.documentElement.style.setProperty('--sidenav-category-txt', `#222222`);
            document.documentElement.style.setProperty('--sidenav-mask', `rgba(0, 0, 0, 0.5)`);
            document.documentElement.style.setProperty('--sidenav-category-columns-bg', `linear-gradient(45deg, #ffffff 0%, #efefef 100%)`);
            //
            document.documentElement.style.setProperty('--pop-search-header-bg', `#ffffff`);
            document.documentElement.style.setProperty('--pop-search-input-bg', `#f2f2f2`);
            document.documentElement.style.setProperty('--pop-search-back-icon-color', `#222222`);
            document.documentElement.style.setProperty('--search-bg', `#ffffff`);
            document.documentElement.style.setProperty('--search-item-bg', `#f2f2f2`);
            document.documentElement.style.setProperty('--search-item-bg-active', `#ffd259`);
            document.documentElement.style.setProperty('--search-item-txt', `#222222`);
            document.documentElement.style.setProperty('----provider-bg', `#ffffff`);
            document.documentElement.style.setProperty('----provider-text', `#222222`);
            document.documentElement.style.setProperty('----game-bg', `#ebebeb`);
        }
        // window.location.reload();
    },[themeName])
    return(<></>)
}

export default ChangeThemes;